import { UpdateClientRoleInput } from '@app/models/client_role.model'

export const SET_CLIENT_ROLE = `
mutation create_client_role($data: CreateClientRoleInput!) {
    create_client_role(data: $data) {
        success
        errorText
        data {
            id
            name
        }
    }
}
`

export const UPDATE_CLIENT_ROLE = `
mutation update_client_role($data: UpdateClientRoleInput!) {
    update_client_role(data: $data) {
        success
        errorText
        data {
            id
            name
        }
    }
}
`

/** Role fields shared by both get_client_roles documents. */
const CLIENT_ROLE_FIELDS = `${Object.keys(new UpdateClientRoleInput()).join('\n')}
            is_system
            members_count`

export const GET_CLIENT_ROLES = `
query get_client_roles($category: clientRoleCategoryType) {
    get_client_roles(
        category: $category
    ) {
        success
        errorText
        data {
            ${CLIENT_ROLE_FIELDS}
        }
    }
}
`

/**
 * One page of the passes assigned to a single role — the role drawer's member list (YB-2073).
 *
 * This is what a screen showing ONE role should ask for. `members_count` above covers the count
 * on the role cards, so between them nothing needs the whole-member-list document any more.
 *
 * `search` matches name, last name and vehicle number, server-side and after decryption. Note
 * there is no `code` in the selection: PAPI does not expose the pass code here on purpose.
 */
export const GET_PASSES_BY_CLIENT_ROLE = `
query get_passes_by_client_role($client_role_id: Float!, $search: String, $skip: Float, $take: Float) {
    get_passes_by_client_role(client_role_id: $client_role_id, search: $search, skip: $skip, take: $take) {
        success
        errorText
        total
        data {
            id
            name
            last_name
            mobile
            vehicle_number
            allowed
        }
    }
}
`

/** get_client_roles including the per-role pass members. Resolving employees is expensive on
 *  PAPI (one row per assigned pass — tens of thousands for role-heavy tenants, YB-1985), so only
 *  screens that actually render member counts/lists (roles/authorized settings) should use it. */
export const GET_CLIENT_ROLES_WITH_EMPLOYEES = `
query get_client_roles($category: clientRoleCategoryType) {
    get_client_roles(
        category: $category
    ) {
        success
        errorText
        data {
            ${CLIENT_ROLE_FIELDS}
            employees{
                id
                name
                last_name
            }
        }
    }
}
`
